module.exports = __webpack_public_path__ + "media/images/lp_v6_mv_pict01_pc02-3377ba940fbb61b5e59f3f00e7cb4613.webp";